import React, { useRef, useState, useEffect } from "react";
import useDarkMode from '../../../hooks/useDarkMode';
import useThemeColor from "../../../hooks/useThemeColor";
import { useSelector } from "react-redux";
import showErrorToast from "../toast/toast";
import { validateImageFile } from "../../../utils/mediaImageUtils";

const ImageUpload = ({ 
  imageUrl, 
  setImage,  
  imageFile, 
  className = "",
  marginLeft = "40px", 
  height = "180px",
  width = "180px",
  buttonText = "Change image",
  uploadText = "Upload Image",
  onRemove,
  centerButton = false,
  useGrid = true
}) => {
  const fileInputRef = useRef(null);
  const isDarkMode = useDarkMode();
  const appSettings = useSelector((state) => state.appSettings);
  const { appTheme } = appSettings;

  // Get theme color from centralized hook
  const themeColor = useThemeColor();

  
  

  const handleRemoveImage = () => {
    setImage("", null);
    if (onRemove) onRemove(); // call parent if needed
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
 
    if (file) {
      const validation = validateImageFile(file, { includeFileName: false });
      if (!validation.valid) {
        showErrorToast(validation.message || "Invalid image file");
        if (fileInputRef.current) fileInputRef.current.value = "";
        return;
      }

      const reader = new FileReader();
      reader.onload = (event) => {
        setImage(event.target.result, file);  
      };
      reader.readAsDataURL(file);
    }
  };

  const containerClass = useGrid ? `col-md-3 text-center ${className}` : `text-center ${className}`;
  const buttonDivClass = `d-flex ${centerButton ? 'justify-content-center' : ''}`;
  const buttonStyle = { marginLeft: centerButton ? "0" : marginLeft };

  return (
    <>
      <div className={containerClass}>
        <div
          className="overflow-hidden position-relative mb-3 mx-auto"
          style={{
            width: width,
            height: height,
            border: imageUrl ? "none" : (isDarkMode ? "2px dashed #555" : "2px dashed #D9D9D9"),
            borderRadius: "20px",
            backgroundColor: isDarkMode ? '#404040' : '#ffffff',
          }}
        >
          {imageUrl ? (
            <>
              <img
                src={imageUrl}
                className="img-fluid"
                alt="Item preview"
                style={{
                  objectFit: "cover",
                  width: "100%",
                  height: "100%",
                  cursor: "pointer",
                  borderRadius: "20px",
                }}
                onClick={() => fileInputRef.current?.click()}
              />
              <i
                className="fa fa-times text-danger position-absolute"
                style={{
                  top: "10px",
                  right: "10px",
                  cursor: "pointer",
                  fontSize: "1rem",
                  background: "rgba(255, 255, 255, 0.8)",
                  padding: "3px",
                  borderRadius: "50%",
                }}
                onClick={handleRemoveImage}
              ></i>
            </>
          ) : (
            <div
              className="d-flex flex-column align-items-center justify-content-center h-100"
              style={{ 
                cursor: "pointer",
                color: isDarkMode ? '#ffffff' : '#6c757d'
              }}
              onClick={() => fileInputRef.current?.click()}
            >
              <i className="fa-solid fa-image" style={{ fontSize: "2.5rem", color: isDarkMode ? '#ffffff' : '#6c757d' }}></i>
              <p className="mt-2 mb-0" style={{ color: isDarkMode ? '#ffffff' : '#6c757d' }}>{uploadText}</p>
            </div>
          )}
          <input
            type="file"
            accept="image/*"
            className="d-none item-image-input"
            onChange={handleImageChange}
            ref={fileInputRef}
          />
        </div>
      </div>
      {imageUrl && (
        <div className={buttonDivClass} style={buttonStyle}>
          <button
            className="btn btn-sm rounded-pill"
            onClick={() => fileInputRef.current?.click()}
            style={{
              backgroundColor: themeColor,
              borderColor: themeColor,
              color: 'white',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = themeColor + 'dd';
              e.currentTarget.style.transform = 'translateY(-1px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = themeColor;
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
           {buttonText}
          </button>
        </div>
      )}
    </>
  );
};

export default ImageUpload;